import type {
  ProductDto,
  EntityNamingDto,
} from "../../../RoyalFloraHolland.Aap.Services.Api.Web.Kiota/Typescript/Api/models/index";
import { formatDate, formatDateTime } from "../utils/dateFormat";

export interface ProductDetail {
  code?: number | null;
  name?: string | null;
  toepassing?: string | null;
  artikelgroep?: string | null;
  createdAt?: string | null;
  experationDate?: string | null;
  modifiedBy?: string | null;
  mutationDate?: string | null;
  vbnDate?: string | null;
  // Nested data for tabs
  crop?: ProductDto["crop"];
  productGroup?: ProductDto["productGroup"];
  productCharacteristics?: ProductDto["productCharacteristics"];
  regulatoryCharacteristics?: ProductDto["regulatoryCharacteristics"];
  coolingRegimeProducts?: ProductDto["coolingRegimeProducts"];
  coolingRegimeProductGroups?: ProductDto["coolingRegimeProductGroups"];
  entityNamings?: ProductDto["entityNamings"];
}

/**
 * Maps ProductDto from API to ProductDetail for UI
 */
export function mapProductDtoToDetail(
  dto: ProductDto | null | undefined,
): ProductDetail | null {
  if (!dto) {
    return null;
  }

  interface NewType {
    entityNamings?: EntityNamingDto[] | null;
  }

  const entityNamings = (dto as unknown as NewType).entityNamings ?? null;

  return {
    code: dto.productCode,
    name: dto.productName,
    toepassing: dto.toepassing,
    artikelgroep: dto.productGroup?.name,
    createdAt: formatDate(dto.startDate),
    experationDate: formatDate(dto.endDate),
    modifiedBy: dto.lastModifiedBy,
    mutationDate: formatDate(dto.lastModified),
    vbnDate: formatDateTime(dto.vbnChangeDateTime),
    // Pass through nested data for tabs
    crop: dto.crop,
    productGroup: dto.productGroup,
    productCharacteristics: dto.productCharacteristics,
    regulatoryCharacteristics: dto.regulatoryCharacteristics,
    coolingRegimeProducts: dto.coolingRegimeProducts,
    coolingRegimeProductGroups: dto.coolingRegimeProductGroups,
    entityNamings: entityNamings,
  };
}
